import { render, staticRenderFns } from "./gongxiangHz.vue?vue&type=template&id=28945d9b&scoped=true"
import script from "./gongxiangHz.vue?vue&type=script&lang=js"
export * from "./gongxiangHz.vue?vue&type=script&lang=js"
import style0 from "./gongxiangHz.vue?vue&type=style&index=0&id=28945d9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28945d9b",
  null
  
)

export default component.exports